import React, { Suspense, lazy } from 'react';
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import Root from './Root';
import LoginPage from './LoginPage';
import SignUpPage from './SignUpPage';
import ProfilePage from './ProviderProfilePage';
import SponsorPage from './SponsorPage';
import PlayersPage from './PlayersPage';
import SessionViewer from './SessionsViewer';
import SessionDetailPage from './SessionDetailPage';
import LiveSessionPage from './LiveSessionPage';
import PatientPage from './PatientPage';
import UserProfilePage from './PlayerProfilePage';
import ProtectedRoute from './ProtectedRoute';
import RoleProtectedRoute from './RoleProtectedRoute';
import VerifyEmailPage from './VerifyEmailPage';
import EmailVerifiedPage from './EmailVerifiedPage';
import NotFoundPage from './NotFoundPage';

// The admin area (sign-up keys, accounts, audit) is its own bundle: nobody else downloads it.
const AdminApp = lazy(() => import('./admin/AdminApp'));

function App() {
  const router = createBrowserRouter(createRoutesFromElements(
    <Route path="/" element={<Root />}>
      <Route index element={<LoginPage />} />
      <Route path="login" element={<LoginPage />} />
      <Route path="sign-up" element={<SignUpPage />} />
      <Route path="verify-email" element={<VerifyEmailPage />} />
      <Route path="verify-email/verify/:token" element={<EmailVerifiedPage />} />

      {/* Provider-only routes */}
      <Route path="provider-profile" element={<RoleProtectedRoute allowedRoles={['provider']}><ProfilePage /></RoleProtectedRoute>} />
      <Route path="sponsored-player" element={<RoleProtectedRoute allowedRoles={['provider']}><SponsorPage /></RoleProtectedRoute>} />
      <Route path="players" element={<RoleProtectedRoute allowedRoles={['provider']}><PlayersPage /></RoleProtectedRoute>} />
      <Route path="players/:id" element={<RoleProtectedRoute allowedRoles={['provider']}><PatientPage /></RoleProtectedRoute>} />

      {/* Player-only routes */}
      <Route path="player-profile" element={<RoleProtectedRoute allowedRoles={['player']}><UserProfilePage /></RoleProtectedRoute>} />

      {/* Shared routes - both roles can access */}
      <Route path="sessions" element={<ProtectedRoute><SessionViewer /></ProtectedRoute>} />
      <Route path="sessions/:id" element={<ProtectedRoute><SessionDetailPage /></ProtectedRoute>} />
      <Route path="live" element={<ProtectedRoute><LiveSessionPage /></ProtectedRoute>} />
      <Route path="live/:sessionId" element={<ProtectedRoute><LiveSessionPage /></ProtectedRoute>} />

      {/* Admin area: its own sign-in (password + authenticator code) and frame */}
      <Route path="admin/*" element={<Suspense fallback={null}><AdminApp /></Suspense>} />

      <Route path="*" element={ <NotFoundPage/> }></Route>
    </Route>
  ));

  return <RouterProvider router={router} />;
}

export default App;
